import { MemberTableSubject } from "@components/common/faro-table/faro-table-types";
import {
  DEFAULT_TEAM_MEMBERS_SORT_BY,
  DEFAULT_MEMBERS_SORT_BY,
  MEMBERS_SORT_BY_MAP,
  MEMBERS_SORT_OPTIONS,
  TEAM_MEMBERS_SORT_BY_MAP,
  TEAM_MEMBERS_SORT_OPTIONS,
} from "@components/table/members/members-sort-constants";
import { MembersSortField } from "@components/table/members/members-table-constants";
import { MembersSortBy } from "@custom-types/member-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { getMembersSortBy, getTeamMembersSortBy } from "@utils/member-utils";
import { isFieldVisibleForTableSubject } from "@components/table/members/members-table-utils";
import { SortOption } from "@custom-types/sort-types";
import { MembersSortBase } from "@components/table/members/members-sort-base";

export interface TeamMembersSortProps {
  tableSubject: "team";
  sortBy: FaroCoreApiTypes.TeamMemberSortBy;
  setSortBy: (sortBy: FaroCoreApiTypes.TeamMemberSortBy) => void;
}

export interface MembersSortProps {
  tableSubject: Exclude<MemberTableSubject, "team">;
  sortBy: MembersSortBy;
  setSortBy: (sortBy: MembersSortBy) => void;
}

/** Component to change the members sort criteria */
export function MembersSort(props: TeamMembersSortProps): JSX.Element;
export function MembersSort(props: MembersSortProps): JSX.Element;
export function MembersSort(
  props: TeamMembersSortProps | MembersSortProps
): JSX.Element {
  const { tableSubject, sortBy, setSortBy } = props;

  if (tableSubject === "team") {
    return (
      <MembersSortBase
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortOptions={TEAM_MEMBERS_SORT_OPTIONS}
        sortByMap={TEAM_MEMBERS_SORT_BY_MAP}
        defaultSortBy={DEFAULT_TEAM_MEMBERS_SORT_BY}
        getSortBy={getTeamMembersSortBy}
        subjectType="Team Member"
      />
    );
  }

  const filteredSortOptions = Object.fromEntries(
    Object.entries(MEMBERS_SORT_OPTIONS).filter(([, { field }]) =>
      isFieldVisibleForTableSubject(field, tableSubject)
    )
  ) as Record<MembersSortField, SortOption<MembersSortField>>;

  return (
    <MembersSortBase
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOptions={filteredSortOptions}
      sortByMap={MEMBERS_SORT_BY_MAP}
      defaultSortBy={DEFAULT_MEMBERS_SORT_BY}
      getSortBy={getMembersSortBy}
      subjectType="Member"
    />
  );
}
